import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-247">
      <div className="max-w-3xl mx-auto text-center" data-id="element-248">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-249">
          Si sos profe de tenis en Argentina,
          <br data-id="element-250" />
          <span className="text-[#00B4D8]" data-id="element-251">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-252">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-253">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-254">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-255">
              Llegás a la cancha sin saber exactamente qué ejercicio vas a dar
              hoy
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-256">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-257">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-258">
              Tus alumnos principiantes no progresan porque no tenés una
              secuencia clara de niveles
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-259">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-260">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-261">
              El 60% de los alumnos abandona antes del año y no sabés cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-262">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-263">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-264">
              Cuando llueve cancelás y perdés el ingreso porque no tenés un Plan
              B listo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-265">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-266">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-267">
              No podés justificar un aumento de precio porque no tenés un
              sistema profesional visible
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-268">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-269">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-270">
              Siempre las mismas correcciones improvisadas, sin un método claro
              que te respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-271">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-272">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-273">
              Tenés alumnos de distintas edades y categorías juntos y la clase
              se convierte en un caos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-274">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-275">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-276">
              Fin de mes y no sabés exactamente cuánto vas a cobrar porque el
              cobro es un desastre
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-8" data-id="element-277">
          ¿Cuántas clases más vas a improvisar?
        </p>

        {/* Blue divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-278" />
      </div>
    </section>;
}